export const KeyboardShortcutsData = [
  { action: 'Play/Pause', keys: ['Tab'] },
  { action: 'Skip Forward', keys: ['F8'] },
  { action: 'Rewind', keys: ['Shift', 'Tab'] },
  { action: 'Paste Text', keys: ['Ctrl', 'V'] },
  { action: 'Undo', keys: ['Ctrl', 'Z'] },
  { action: 'Redo', keys: ['Ctrl', 'Y'] },
  { action: 'Save', keys: ['Ctrl', 'S'] },
  { action: 'Copy', keys: ['Ctrl', 'C'] },
  { action: 'Find', keys: ['Ctrl', 'F'] },
  { action: 'Find and Replace', keys: ['Ctrl', 'F'] },
  { action: 'Mark paragraph as completed', keys: ['Ctrl', 'M'] },
  { action: 'Select next speaker', keys: ['Ctrl', 'Enter'] },
  { action: 'Open speaker selector', keys: ['Ctrl', 'Shift', 'Enter'] },
];
